import './job-bookmark.scss';

class JobBookmarkList {
    constructor ($element) {
        this.$jobBookmarkList = $element;
        this.$jobPerPageSelector = this.$jobBookmarkList.querySelector('[data-job-per-page-selector="root"]');
        this.storedItems = localStorage.getItem('bookmarkedJobs');

        if (this.storedItems !== undefined) {
            this.initialize();
        }
    }

    initialize () {
        this.updateBookedURLAndReloadPage();

        window.addEventListener('update.bookmarks', (e) => {
            if (e.detail) {
                this.updateBookedURLAndReloadPage();
            }
        });

        if (this.$jobPerPageSelector) {
            this.$jobPerPageSelector.onchange = () => {
                this.changePageResults(this.$jobPerPageSelector.value);
            };
        }
    }

    changePageResults (jobsPerPage) {
        const currentParams = new URLSearchParams(window.location.search);
        const bookedParam = currentParams.get('booked');
        const paginationParam = '1'; // reset the page pagination param always to 1 if change the jobs per page amount to prevent no results on page
        const bookedURL = `?booked=${bookedParam}&page=${paginationParam}&job-number=${jobsPerPage}`;

        history.replaceState(history.state, '', bookedURL);
        location.reload();
    }

    updateBookedURLAndReloadPage () {
        const bookedIds = [];

        const storedJobs = JSON.parse(localStorage.getItem('bookmarkedJobs')) || [];
        if (storedJobs.length > 0) {
            storedJobs.forEach((job) => {
                bookedIds.push(job.id);
            });
        }

        const bookedParam = bookedIds.join(',');
        const currentParams = new URLSearchParams(window.location.search);
        let paginationParam = currentParams.get('page');

        if (paginationParam === undefined || paginationParam < 1) {
            paginationParam = 1;
        }

        // update current url with new url because all data that is disabled comes from the get params
        if (currentParams.get('booked') !== bookedParam) {
            const bookedURL = `?booked=${bookedParam}&page=${paginationParam}`;
            history.replaceState(history.state, '', bookedURL);
            location.reload(); // reload page if not identical with data
        }

        // toDo FE
        // this is current state of the origin page with the improvement of reload if the data is not correct
        // for future updates we should get all data via ajax, so we load the page /booked and then make a request to /booked?booked=29241,28085,28548&page=1 and update the root element of this script
    }
}

export { JobBookmarkList };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$jobBookmarkList = $context.querySelectorAll('[data-job-bookmark-list="root"]');

    if ($$jobBookmarkList.length > 0) {
        $$jobBookmarkList.forEach(($jobBookmarkList) => {
            const jobBookmarkList = new JobBookmarkList($jobBookmarkList); // eslint-disable-line
        });
    }
});